import { IS_LOAD_ASSETS_FROM_URL, STATIC_PATH } from "constants/common";
import jwtDecode from "jwt-decode";

function formatNumber(n, symbol) {
  let parts = n ? n.toString().split(".") : "0";
  return (
    parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, symbol) +
    (parts[1] ? "," + parts[1] : "")
  );
}

function urlAssetsCustom(path) {
  if (JSON.parse(IS_LOAD_ASSETS_FROM_URL)) {
    return STATIC_PATH + path;
  }
  return path;
}
const calcDayInWeek = (number) => {
  switch (number) {
    case 1:
      return "Thứ 2";
    case 2:
      return "Thứ 3";
    case 3:
      return "Thứ 4";
    case 4:
      return "Thứ 5";
    case 5:
      return "Thứ 6";
    case 6:
      return "Thứ 7";
    default:
      return "Chủ nhật";
  }
};
const testEmail = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(value);
};
const handleScroll = (elementId) => {
  document.getElementById(elementId).scrollIntoView({ behavior: "smooth" });
};

const shareImage = async (file, fileName) => {
  if (navigator.share) {
    try {
      // const fileContent = new File([file], fileName, { type:"image/png" });

      await navigator.share({
        title: "Chia sẻ ảnh",
        // text: "Sharing an awesome image.",
        // url: imageUrl,
        files: [file], // Fallback for browsers that don't support file sharing
      });

      console.log("Image shared successfully!");
    } catch (error) {
      console.error("Sharing failed:", error);
    }
  } else {
    alert("Sharing is not supported in this browser.");
  }
};

const isTokenExpired = (token) => {
  if (!token) return true;
  try {
    const decodedToken = jwtDecode(token);
    const currentTime = Date.now() / 1000;
    return decodedToken?.exp < currentTime;
  } catch (error) {
    console.error("Error decoding token:", error);
    return true;
  }
};

const downloadImage = async (imageUrl, fileName) => {
  try {
    const response = await fetch(imageUrl);
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);

    // Revoke the blob URL to free memory
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Download failed:", error);
  }
};

const base64ToFile = (base64String, fileName) => {
  // Extract content type and base64 data
  const match = base64String.match(/^data:(.*);base64,(.*)$/);
  if (!match) throw new Error("Invalid Base64 string");

  const contentType = match[1];
  const byteCharacters = atob(match[2]); // Decode Base64
  const byteArrays = [];

  for (let i = 0; i < byteCharacters.length; i += 512) {
    const slice = byteCharacters.slice(i, i + 512);
    const byteNumbers = new Array(slice.length)
      .fill(null)
      .map((_, i) => slice.charCodeAt(i));
    byteArrays.push(new Uint8Array(byteNumbers));
  }

  const blob = new Blob(byteArrays, { type: contentType });
  return new File([blob], fileName, { type: contentType });
};
export {
  formatNumber,
  urlAssetsCustom,
  calcDayInWeek,
  handleScroll,
  shareImage,
  isTokenExpired,
  downloadImage,
  base64ToFile,
};
